import React, { useEffect } from 'react';
import './Mobile1.css';

const Mobile1 = () => {
    useEffect(() => {
        console.log('Mobile1 useEffect running');
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    console.log(`${entry.target.className} isIntersecting: ${entry.isIntersecting}`);
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => {
            console.log('Observing:', element);
            observer.observe(element);
        });

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Requirement Analysis Process",
            description: "Gathering and analyzing requirements to define mobile app functionality for IoT systems."
        },
        {
            title: "UI/UX Design Process",
            description: "Designing intuitive UI/UX for seamless interaction with IoT devices."
        },
        {
            title: "Frontend Development Process",
            description: "Building responsive frontends for mobile apps controlling embedded systems."
        },
        {
            title: "Backend Integration Process",
            description: "Integrating mobile apps with backend systems for real-time IoT data processing."
        },
        {
            title: "IoT Device Connectivity Process",
            description: "Enabling secure connectivity between mobile apps and IoT devices."
        },
        {
            title: "API Development Process",
            description: "Developing APIs to facilitate communication between apps and IoT platforms."
        },
        {
            title: "Testing and Debugging Process",
            description: "Conducting rigorous testing to ensure app reliability and performance."
        },
        {
            title: "App Store Deployment Process",
            description: "Deploying mobile apps to iOS and Android stores for global access."
        },
        {
            title: "Maintenance and Updates Process",
            description: "Providing ongoing updates to enhance app functionality and security."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Mobile App Development
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our mobile app development services deliver intuitive, reliable, and efficient solutions for IoT and embedded systems, ensuring seamless device control and user experience.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Mobile1;